import React, { Component } from 'react';
import ModalGE from 'src/Components/ModalGE/ModalGE';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PrimaryButtonGE from 'src/Components/PrimaryButtonGE/PrimaryButtonGE';
import SecondaryButton from 'src/Components/SecondaryButton/SecondaryButton';
import './styles.scss';
import { withTranslation } from 'react-i18next';

class UpdateUserModal extends Component {
  state = {
    showConfirmation: false,
  };
  cancelAction = () => {
    this.props.cancelSelection();
  };

  updateUserFn = () => {
    let { activationKey, userDetails, isDisabled, searchKey } = this.props;
    this.props.updateUser(
      activationKey,
      isDisabled,
      userDetails.emailId,
      searchKey
    );
    this.props.cancelSelection();
  };

  disableAccount = (val) => {
    this.setState({
      showConfirmation: val,
    });
  };

  showRoles = (entRoles) => {
    const { t } = this.props;
    let roles = entRoles.map((role) => {
      if (role === 'ADMIN') {
        role = t('admin');
      } else if (role === 'PARTICIPANT') {
        role = t('user');
      } else if (role === 'TRAINER') {
        role = t('expert');
      }
      return role;
    });
    let userRoles = roles.sort().join(' : ');
    return <span>{userRoles}</span>;
  };

  render() {
    let { showConfirmation } = this.state;
    let { isDisabled, userDetails } = this.props;
    let truncatedName = userDetails?.firstName+' '+ userDetails?.lastName;
    const { t } = this.props;
    let userDept;
    if (userDetails['department']) userDept = ` ${t('In')} ${userDetails['department']}`;
    else userDept = '-';

    let userInfo;
    if (userDetails['jobTitle']) userInfo = (
      <>
        <span>{userDetails.jobTitle}</span>
        {userDept}
      </>
      )
    else userInfo = (
      '-'
    )

    let accountInfo;
    if (userDetails.entRoles && userDetails.entRoles.length > 0) accountInfo = this.showRoles(userDetails.entRoles);
    else accountInfo = '-';

    return (
      <div className="admin-user-modal-container">
        <ModalGE isOpen={true} onDismiss={this.cancelAction} isBlocking={true}>
          <div className="admin-user-modal-wrapper">
            <div className="account-logo">
              <p className="account-initial">
                {this.populateUserdetails(userDetails,'FIRSTNAME')}
              </p>
            </div>
            <p className="account-name">
              {userDetails
                ? truncatedName
                : ''}
            </p>
            <div className="details-wrapper">
              <div className="details-info">
                <FontAwesomeIcon icon={faEnvelope} color={'#D7D8DB'} />
                <p className="details-text">
                  {userDetails ? userDetails.emailId : '-'}
                </p>
              </div>
              {!isDisabled ? (
                <>
                  <div className="details-info">
                    <FontAwesomeIcon icon={faPhone} color={'#D7D8DB'} />
                    <p className="details-text">
                      {this.populateUserdetails(userDetails, 'PHONENUMBER')}
                    </p>
                  </div>
                  <p className="account-info">
                    {userInfo}
                  </p>
                  <p className="account-info">
                    {accountInfo}
                  </p>
                </>
              ) : null}
            </div>
            <div className="buttons-container">
              {showConfirmation ? (
                <div className="user-confirmation-wrapper">
                  <p className="confirm-heading">{t('confirmationHeading')}</p>
                  <div className="confirm-buttons">
                    <PrimaryButtonGE
                      text={t('confirmDisableAccount')}
                      disabled={false}
                      onClick={this.updateUserFn}
                    />
                    <SecondaryButton
                      text={t('cancel')}
                      onClick={this.disableAccount.bind(this, false)}
                    />
                  </div>
                </div>
              ) : (
                <>
                  {!isDisabled ? (
                    <div className="button-wrapper">
                      <SecondaryButton
                        text={t('disableDEAccount')}
                        onClick={this.disableAccount.bind(this, true)}
                      />
                    </div>
                  ) : (
                    <div className="button-wrapper">
                      <SecondaryButton
                        text={t('grantDEAccess')}
                        onClick={this.updateUserFn}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </ModalGE>
      </div>
    );
  }

  populateUserdetails = (userDetails, param) =>{
    
    switch(param){
      case 'FIRSTNAME':
        let profileName ='';
        if(userDetails)
        {
          if(userDetails.firstName)
          {
            profileName = userDetails.firstName.charAt(0).toUpperCase();
          }
          if(userDetails.lastName)
          {
            profileName += userDetails.lastName.charAt(0).toUpperCase();
          }
          else
          {
            profileName += '';
          }
        }
        return profileName;
      case 'PHONENUMBER':
        let phoneNum = '-';
        if(userDetails)
        {
          if(userDetails.workPhoneNumber){
            phoneNum = userDetails.workPhoneNumber;
          }
        }
        return phoneNum;
    }

  }
}

export default withTranslation()(UpdateUserModal);
